module.exports = __webpack_public_path__ + "static/media/wind_strong.21db6788.svg";